import React from "react";
import L from "leaflet";
import "leaflet-geotiff-2";
import "leaflet-geotiff-2/dist/leaflet-geotiff-plotty";
import { withLeaflet, MapLayer } from "react-leaflet";
import * as plotty from "leaflet-geotiff-2/node_modules/plotty";
import { palettes } from "../../../common/VisualizationPresets/colorPalettes";

/** Plotty rejects / mishandles the literal scale name "default"; use a prefixed id. */
const ELEVATION_PLOTTY_BREAKS = [
  0, 0.12, 0.24, 0.36, 0.48, 0.6, 0.72, 0.84, 1,
];

function ensurePlottyElevationColorScale(paletteKey) {
  const key =
    paletteKey && palettes.colors.elevation[paletteKey]
      ? paletteKey
      : palettes.defaults.elevation;
  const colors = palettes.colors.elevation[key];
  const scaleName = `ccElev_${key}`;
  if (!colors) {
    return ensurePlottyElevationColorScale(palettes.defaults.elevation);
  }
  if (!Object.hasOwn(plotty.colorscales, scaleName)) {
    plotty.addColorScale(scaleName, colors, ELEVATION_PLOTTY_BREAKS);
  }
  return scaleName;
}

export const GeotiffLayer = withLeaflet((props) => {
  return <PlottyGeotiffLayer {...props} />;
});

export class PlottyGeotiffLayer extends MapLayer {
  constructor(props) {
    super(props);
    this._lastPublishedBoundsKey = null;
  }

  createLeafletElement(props) {
    const { topographyUrl, maxElevation, minElevation } = props;

    const colorScale = ensurePlottyElevationColorScale(
      this.props.nameOfElevationPallete
    );

    let plottyRenderer = L.LeafletGeotiff.plotty({
      displayMin: minElevation,
      displayMax: maxElevation,
      colorScale,
    });

    let leafletGeotiff = new L.leafletGeotiff(topographyUrl, {
      renderer: plottyRenderer,
      noDataValue: undefined,
      noDataKey: undefined,
      blockSize: 65536,
      opacity: 0.5,
    });

    return leafletGeotiff;
  }

  componentDidMount() {
    const { map } = this.props.leaflet;
    if (!map || !this.props.topographyUrl) {
      return;
    }
    this.leafletElement.addTo(map);
    this.publishLeafletBoundsWhenReady();
  }

  /**
   * GeoRaster xmin/ymax are often in the raster CRS; Leaflet GeoTIFF reports correct lat/lng bounds after decode.
   */
  publishLeafletBoundsWhenReady() {
    const onTopographyMapBounds = this.props.onTopographyMapBounds;
    if (typeof onTopographyMapBounds !== "function") {
      return;
    }
    let attempts = 0;
    const maxAttempts = 40;
    const tick = () => {
      attempts += 1;
      try {
        const layer = this.leafletElement;
        const b = layer?.getBounds?.();
        if (b && typeof b.isValid === "function" && b.isValid()) {
          const payload = [
            [b.getSouth(), b.getWest()],
            [b.getNorth(), b.getEast()],
          ];
          const key = JSON.stringify(payload);
          if (key !== this._lastPublishedBoundsKey) {
            this._lastPublishedBoundsKey = key;
            onTopographyMapBounds(payload);
          }
          return;
        }
      } catch (_e) {
        /* layer not ready yet */
      }
      if (attempts < maxAttempts) {
        window.setTimeout(tick, 100);
      }
    };
    window.setTimeout(tick, 0);
  }
}
